import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

const DEFAULT_FAQS = [
  { q: "Why use Digital24 for guaranteed placements?", a: "You choose the exact publication, we guarantee it publishes, and you see exactly what you get (link type, format, turnaround) before you pay. If it does not publish, you get a full refund." },
  { q: "How does the process work?", a: "Choose your outlets, submit your content, we place it on the named publication with same-day submission, and you receive the live published link." },
  { q: "What kind of content can I publish?", a: "Press releases, thought leadership articles, op-eds, and guest posts. What each publication accepts varies, and we tell you upfront." },
  { q: "Can I choose the exact publication?", a: "Yes. Pick a single publication or as many as you want." },
  { q: "Is the link dofollow?", a: "It depends on the publication. We offer dofollow, nofollow, and sponsored links, and we disclose the link type for each outlet before you buy." },
  { q: "Do you accept my industry, including niche or restricted sectors?", a: "We accept a wide range of industries, including many niche and restricted sectors. Availability depends on the specific publication." },
  { q: "How long until it goes live?", a: "Submission is same-day. Publication timing varies by outlet, and we share the expected turnaround before you order." },
  { q: "What is the refund policy?", a: "Published or full refund. If we cannot get your article published on the outlet you chose, you get your money back." },
  { q: "Will my article stay up permanently?", a: "Most placements stay up permanently. However, these are third-party publications, so if a publisher chooses to remove an article, that is their editorial decision and outside our control." },
  { q: "When should I use guaranteed placements instead of newswire?", a: "Use guaranteed placements when you want a named article on a specific publication with full attribution. Use newswire distribution when you want broad syndication and reach across many outlets." },
];

export default function ServiceFAQ({ faqs = DEFAULT_FAQS, tag = "FAQ", title = "Frequently Asked Questions" }) {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-canvas">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading tag={tag} title={title} />
        </Reveal>
        <Reveal delay={0.08}>
          <Accordion type="single" collapsible>
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-bone hover:text-cobalt text-left font-heading text-base py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-steel text-sm leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}